"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.submitFlowsBase = void 0;
var tslib_1 = require("tslib");
var submitDeleteFlowsBase_1 = require("./delete/submitDeleteFlowsBase");
var submitNewFlowsBase_1 = require("./new/submitNewFlowsBase");
var submitWorkspaceNameF_1 = require("./submitWorkspaceNameF");
exports.submitFlowsBase = tslib_1.__spreadArray(tslib_1.__spreadArray(tslib_1.__spreadArray([], submitDeleteFlowsBase_1.submitDeleteFlowsBase, true), submitNewFlowsBase_1.submitNewFlowsBase, true), [
    submitWorkspaceNameF_1.submitWorkspaceNameF,
], false);
